export default __webpack_public_path__ + "static/media/placeholder_store05-nl-web.a77dbebf.png";